export const selectOpeningListLoading = (state) => state.browseReducer.isLoadingOpeningList;
export const selectLoadingJobs = (state) => state.browseReducer.isLoadingOrgJobs;
export const selectOpeningDetailsLoading = (state) => state.browseReducer.isLoadingOpeningDetails;
export const selectJobOpeningDetailsLoading = (state) => state.browseReducer.isLoadingJobOpeningDetails;
export const selectOpeningList = (state) => state.browseReducer.openingsList;
export const selectPaginationInfo = (state) => state.browseReducer.paginationInfo;
export const selectOpeningDetails = (state) => state.browseReducer.openingDetails;
export const selectSearchOpeningDetails = (state) => state.browseReducer.searchOpeningDetails;
export const selectSearchOpeningLoading = (state) => state.browseReducer.isLoadingSearchList;
export const selectMoreJobsloading = (state) => state.browseReducer.fetchMoreJobsLoading;
export const selectSortBy = (state) => state.browseReducer.sortBy;
